import { Navigate, useLocation } from 'react-router-dom';

/** Planning report is shown on the combined assessment screen (assessment-first journey). */
export default function PlanningInfoScreen() {
  const location = useLocation();
  return <Navigate to="/assessment" replace state={location.state} />;
}
